import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import DownloadLink from '../../../components/common/DownloadLink';
import { getExportFileName } from '../helpers/budgetReportHelper';

export default function PlanBudgetMeetings() {
  return (
    <Row className="mb-12">
      <Form.Group as={Col}>
        <DownloadLink
          variant="primary"
          type="submit"
          url="/panels/buys/export"
          filename={getExportFileName('Перечень закупок')}
          style={{ marginTop: '30px' }}
        >
          Сформировать повестку
        </DownloadLink>
      </Form.Group>
    </Row>
  );
}
